import { useNavigate } from "react-router-dom";
import Tool from "./tool";
import dayjs from "dayjs";
import React, { useState } from "react";
import http from "@/http";
import { useTranslation } from "react-i18next";

export default function Faq() {
  const navigate = useNavigate();
  const [active, setActive] = useState(-1);
  const { t, i18n } = useTranslation();

  const checkActive = async (idx, item) => {
    if (active === idx) {
      setActive(-1);
    } else {
      setActive(idx);
      item.click++;
      await http.get("/system/NftFQA/" + item.id);
    }
  };

  return (
    <Tool
      key={i18n.language}
      title="FAQ"
      url="/system/NftFQA/list"
    >
      {({ list }) => (
        <div className="official-table">
          <table>
            <thead>
              <tr>
                <td></td>

                <td>{t("announcement.Category")}</td>
                <td>{t("announcement.Title")}</td>
                <td>{t("announcement.date_posted")}</td>
                <td></td>
              </tr>
            </thead>
            <tbody>
              {list.map((item, idx) => (
                <React.Fragment key={item.id}>
                  <tr
                    className="cursor-pointer"
                    onClick={() => checkActive(idx, item)}
                  >
                    <td>
                      <img src="/assets/img/image_14.png" alt="" />
                    </td>
                    <td style={{ width: "auto" }}>
                      {item.top == 1 && (
                        <span className="badge">
                          {t("announcement.Recommend")}
                        </span>
                      )}
                      {t(`announcement.faq_type_${item.type}`)}
                    </td>
                    <td>{item.title}</td>
                    <td>
                      {" "}
                      {dayjs(item.createTime).format("YY.MM.DD HH:mm:ss")}
                    </td>
                    <td>
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10.0208 13.209L4.5625 7.75065L6.10417 6.20898L10.0208 10.1257L13.9375 6.20898L15.4792 7.75065L10.0208 13.209Z"
                          fill="#2B2B2B"
                        />
                      </svg>
                    </td>
                  </tr>
                  {active === idx && (
                    <tr>
                      <td colSpan={5} style={{ padding: 0 }}>
                        <div
                          style={{ padding: "22px 30px", color: "#576059" }}
                          dangerouslySetInnerHTML={{ __html: item.content }}
                        ></div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Tool>
  );
}
